<div
  class="statistics-card {{ hasStatusFilter ? 'cursor-pointer' : '' }} {{ !config() ? type() : '' }}"
  [ngClass]="customClasses()"
  [style.max-width.px]="maxWidth()"
  [style.background-color]="config() ? config()!.backgroundColor : ''"
  (click)="statClick.emit(title())"
  (keydown.enter)="statClick.emit(title())">
  <h2
    class="statistics-title"
    [style.color]="config() ? config()!.textColor : ''">
    {{ title() }}
  </h2>

  <div
    class="statistics-value-container"
    [style.backgroundColor]="config() ? config()!.valueBackgroundColor : ''">
    <p
      class="statistics-value"
      [style.color]="config() ? config()!.valueColor : ''">
      {{ value() }}
    </p>
  </div>
</div>
